import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"

const ExhibitorConfig = ({ }) => {
    // Edit functionality
    const { refNumber } = useParams()
    return (
        <div className="page-area">
            Hello ExhibitorConfig!!!
        </div>
    );
}
export default ExhibitorConfig;